import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { useAnalyticsFilters } from '@/contexts/AnalyticsFiltersContext'

/**
 * Wraps useQuery so every analytics fetch is keyed by the full filter object
 * and hits `/api/analytics/...` with the filters folded into the query string.
 */
export function useAnalyticsQuery<T = unknown>(
  scope: string,
  path: string,
  options?: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>,
): UseQueryResult<T> {
  const { queryParams } = useAnalyticsFilters()

  return useQuery<T>({
    queryKey: ['analytics', scope, queryParams],
    queryFn: async () => {
      const response = await api.get(path, { params: queryParams })
      return response.data as T
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}
